import SubApp from '@components/SubApp';

export default function MyPage(props) {
  const { platform } = props.match.params;
  return <SubApp app={platform} />;
}
